import React from 'react';
import { AppLayout } from '../../layouts/AppLayout';
import { useSubscriptionData } from '../../../hooks/useSubscriptionData';
import { SubscriptionManagement } from './index';

export const SubscriptionManagementPage: React.FC = () => {
  const data = useSubscriptionData();

  return (
    <AppLayout>
      <SubscriptionManagement {...data} />
    </AppLayout>
  );
};

export default SubscriptionManagementPage;
